module.exports = __webpack_public_path__ + "img/banner-3.deb3886f.png";